import { EntityType } from '@frontend/common';
import { GroupSelectV2 } from '@frontend/group/select';
import { NodeType } from '@frontend/group/types';
import { ICONS } from '@frontend/icons';
import { CommonMessage } from '@frontend/lang';
import { CreateProduct, IProduct } from '@frontend/product/types';
import { FormattedMessage } from 'react-intl';

import CreateModal from '../../../../modal/create-modal/create-modal.component';
import { FORM_ID, useCreateProductModal } from './create-product-modal.controller';

export const CreateProductModal = () => {
    const { values, addCategory, removeCategory, updateCategory, onSubmit, submitDisabled } = useCreateProductModal();

    return (
        <CreateModal<IProduct, CreateProduct>
            formId={FORM_ID}
            order={['name', 'type', 'sku', 'ean', 'description', 'user_info']}
            required={['name', 'type']}
            type={EntityType.PRODUCT}
            onSubmit={onSubmit}
            label={
                <FormattedMessage
                    defaultMessage='Create product'
                    id='create-product-modal.title'
                />
            }
            title={CommonMessage.FORMS.BASIC_INFORMATION}
            enumOverwrite={new Map([['type', 'product_type']])}
            append={
                <div className='mt-2 flex w-full flex-col gap-2'>
                    {values.map((value, index) => (
                        <div
                            key={index}
                            className='flex items-end gap-2'>
                            <div className='flex-1'>
                                <GroupSelectV2
                                    isClearable
                                    type={EntityType.PRODUCT_CATEGORY}
                                    queryParams={{ node_type: [NodeType.BRANCH, NodeType.ROOT] }}
                                    label={CommonMessage.OBJECTS.CATEGORY.PARENT_CATEGORY}
                                    customLabelAction={
                                        index === 0 ? (
                                            <span
                                                onClick={addCategory}
                                                className='text-brand-primary hover:text-brand-secondary cursor-pointer justify-start text-center text-base font-medium'>
                                                <FormattedMessage
                                                    id='create-product-modal.add-another-category'
                                                    defaultMessage='Add another category'
                                                />
                                            </span>
                                        ) : null
                                    }
                                    value={values[index]}
                                    onChange={(v) => updateCategory(index, v)}
                                />
                            </div>
                            {index !== 0 && (
                                <button
                                    type='button'
                                    onClick={() => removeCategory(index)}
                                    className='text-brand-muted hover:text-status-danger mb-2 cursor-pointer p-1'>
                                    <ICONS.BUTTON.CLOSE size={20} />
                                </button>
                            )}
                        </div>
                    ))}
                </div>
            }
            submitDisabled={submitDisabled}
            subForms={
                new Map([
                    [
                        'Translations',
                        {
                            order: ['name_nl_be'],
                            collapsible: true,
                            defaultCollapsed: true,
                            orderTitles: new Map([
                                [CommonMessage.OBJECTS.PRODUCT.PRODUCT_NAME, ['name_nl_be', 'name_en_us', 'name_fr_fr', 'name_de_de']],
                                [
                                    CommonMessage.OBJECTS.PRODUCT.PRODUCT_DESCRIPTION,
                                    ['description_nl_be', 'description_en_us', 'description_fr_fr', 'description_de_de']
                                ],
                                [CommonMessage.OBJECTS.PRODUCT.USER_INFO, ['user_info_nl_be', 'user_info_en_us', 'user_info_fr_fr', 'user_info_de_de']]
                            ])
                        }
                    ]
                ])
            }
        />
    );
};
